// extracted by mini-css-extract-plugin
export default {"primary":"#583372","secondary":"#f7f7f7","contrastTextPrimary":"#fff","light":"#f3f7fa","dark":"#b8eaf0"};